<template>
  <span class="badge" v-bind:class="cssclass">{{ status | t | titlecase }}</span>
</template>
<script>
export default {
  data: function () {
    return {};
  },
  computed: {
    cssclass() {
      let status = this.status;
      switch (status) {
        case 'unknown':
          return { 'badge-dark': true };
        case 'onboarding':
          return { 'badge-warning': true };
        case 'migrating':
          return { 'badge-warning': true };
        case 'migrated':
          return { 'badge-success': true };
        case 'onboarded':
          return { 'badge-success': true };
        case 'drop_point_only':
          return { 'badge-success': true };
        case 'demo':
          return { 'badge-dark': true };
        case 'external':
          return { 'badge-dark': true };
        case 'cancelled':
          return { 'badge-dark': true };
        case 'billing_account':
          return { 'badge-dark': true };
      }
    }
  },
  props: ['status']
};
</script>
